module.exports = __webpack_public_path__ + "static/media/ste_2016_rimini_5.0b88061c.jpg";